import React, {useState, useEffect} from 'react';

function LoginFooter() {
    const [currentYear, setCurrentYear] = useState('');

    useEffect(() => {
        const d = new Date();
        setCurrentYear(d.getFullYear());
    }, [])
    
    return (
        <footer className="border-t border-white/5 py-6 text-center">
            <p className="text-white/20 text-xs">© {currentYear} ACCLiveTelemetry. Developed for the SimRacing Community.</p>
        </footer>
    );
}

export default LoginFooter;